import {neverland as $, html, useState, useEffect} from 'neverland';

import Select from './Select.js';
import translations from './translations.js';

import JGIcodes from './JGIcodes.js';

const Login = $(function(auth, setPage, theme, a11y, setA11y) {

	let [a11yOpen, setA11yOpen] = useState(false);

	function toggleA11y(key) {
		setA11y(prev => ({ ...prev, [key]: !prev[key] }));
	}

	function slideA11y(key) {
		return (e) => setA11y(prev => ({ ...prev, [key]: e.target.value }));
	}

	let [language, setLanguage] = useState('EN');

	let [text, setText] = useState(translations['EN']);

	useEffect(() => {
		setText(translations[language]);
	}, [language])

	useEffect(() => {
		let lang = (new URLSearchParams(window.location.search)).get('language');
		if (lang !== null) {
			setLanguage(lang);
		}
	}, [])

	function getCodeBoxElement(index) {
		return document.getElementById('ac' + index);
	}

	function handleKeyUp(index) {
		return (event) => {
			const eventCode = event.which || event.keyCode;
			const inp = getCodeBoxElement(index)
			if (inp.value.length > 1){
				inp.value = inp.value.substr(0, 1)
			}
			if (getCodeBoxElement(index).value.length === 1) {
				if (index !== 6) {
					getCodeBoxElement(index+ 1).focus();
				} else {
					getCodeBoxElement(index).blur();
					document.getElementById('err-noSurvey').style.height = "0";
					document.getElementById('err-notNumber').style.height = "0";
					document.getElementById('loading-animation').style.display = "block";
					loadSurvey(auth);
				}
			}
			if (eventCode === 8 && index !== 1) {
				getCodeBoxElement(index - 1).value = "";
				getCodeBoxElement(index - 1).focus();
			}
		}
	}

	function handleKeyPress(index) {
		return (event) => {
			const eventCode = event.which || event.keyCode;
			const inp = getCodeBoxElement(index)
			if (inp.value.length > 1){
				inp.value = inp.value.substr(0, 1)
			}
			if (getCodeBoxElement(index).value.length === 1) {
				if (index !== 6) {
					getCodeBoxElement(index+ 1).focus();
				} else {
					getCodeBoxElement(index).blur();
					document.getElementById('err-noSurvey').style.height = "0";
					document.getElementById('err-notNumber').style.height = "0";
					document.getElementById('loading-animation').style.display = "block";
					loadSurvey(auth);
				}
			}
			if (eventCode === 8 && index !== 1) {
				getCodeBoxElement(index - 1).value = "";
				getCodeBoxElement(index - 1).focus();
			}
		}
	}

	
	function onFocusEvent(index) {
		return () => {
			for (let item = 1; item < index; item++) {
				const currentElement = getCodeBoxElement(item);
				if (!currentElement.value) {
					currentElement.focus();
					break;
				}
			}
		}
	}

	function onKeyPress(index) {
		return () => {
			const currentElement = getCodeBoxElement(index);
			currentElement.value = currentElement.value.substr(0, 1);
			console.log(index, currentElement.value, currentElement.value.substr(0, 1))
			
		}
	}
	
 	useEffect(() => {
 		document.querySelector('#ac1').addEventListener('keyup', handleKeyUp(1))
 		document.querySelector('#ac2').addEventListener('keyup', handleKeyUp(2))
 		document.querySelector('#ac3').addEventListener('keyup', handleKeyUp(3))
 		document.querySelector('#ac4').addEventListener('keyup', handleKeyUp(4))
 		document.querySelector('#ac5').addEventListener('keyup', handleKeyUp(5))
 		document.querySelector('#ac6').addEventListener('keyup', handleKeyUp(6))
 	}, [])

 	var getJSON = function(url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.open('GET', url, true);
		xhr.responseType = 'json';
		xhr.onload = function() {
			var status = xhr.status;
			if (status === 200) {
				callback(null, xhr.response);
			} else {
				callback(status, xhr.response);
			}
		};
		xhr.send();
	};

	function showError(error) {
		document.getElementById('loading-animation').style.display = "none";
		document.getElementById('err-' + error).style.height = "35px";
		jQuery('#shakediv').removeClass().addClass('animated shake').one('webkitAnimationEnd oAnimationEnd', function(){
			jQuery(this).removeClass();
		});
		document.getElementById('ac1').value = "";
		document.getElementById('ac2').value = "";
		document.getElementById('ac3').value = "";
		document.getElementById('ac4').value = "";
		document.getElementById('ac5').value = "";
		document.getElementById('ac6').value = "";
		document.getElementById('ac1').focus();
	}

	function beforeOpenDateDexterous(data) {
		var currentDate = new Date();
		
		if (data.poll.openDate == null) {
			document.getElementById('openDateErrorMessage').textContent = "Call Scott on 0476 282 927 to choose dates for surveying.";
			return(true)
		} else {
			var openDate = new Date(data.poll.openDate.date);
			var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
			document.getElementById('openDateErrorMessage').textContent = "Your survey will open on " + openDate.toLocaleDateString("en-AU", options) + '.';
			return(currentDate < openDate)
		}
	}

	function afterCloseDateDexterous(data) {
		var currentDate = new Date();
		
		if (data.poll.closeDate == null) {
			return(false)
		} else {
			var closeDate = new Date(data.poll.closeDate.date);
			var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
			document.getElementById('closeDateErrorMessage').textContent = "Your surveying period ended on " + closeDate.toLocaleDateString("en-AU", options) + '.';
			return(currentDate > closeDate)
		}
	}

	function beforeOpenDate(date) {
		
		var currentDate = new Date();
		
		var openDate = new Date(date);
		var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
		document.getElementById('openDateErrorMessage').textContent = "Your survey will open on " + openDate.toLocaleDateString("en-AU", options) + '.';

		return(currentDate < openDate)
	}

	function afterCloseDate(date) {
	
		var currentDate = new Date();
		
		var closeDate = new Date(date);
		var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
		document.getElementById('closeDateErrorMessage').textContent = "Your surveying period ended on " + closeDate.toLocaleDateString("en-AU", options) + '.';

		return(currentDate > closeDate)
	}

	function fixURL(url) {
		var regex = /[0-9-]+/g;
		var page = url.match(regex)[0];
		return('https://surveypage.org/' + page + '/');
	}

	const getItemIDs = (itemSet, itemSets) => {
		let itemIDs = [];
		let itemSetIDs = [];
		
		for (let el of itemSet.elements) {
			if (el.collection === "Items") {
				itemIDs.push(el.element);
			} else if (el.collection === "ItemSets") {
				itemSetIDs.push(el.element);
				let foundItemSet = itemSets.find(d => d.id === el.element);
				if (foundItemSet) {
					let [newItemIDs, newItemSetIDs] = getItemIDs(foundItemSet, itemSets);
					itemIDs = itemIDs.concat(newItemIDs);
					itemSetIDs = itemSetIDs.concat(newItemSetIDs);
				}
			}
		}
		
		return [itemIDs, itemSetIDs];
	};
	
	const getSurveyItems = async (survey, auth) => {
		try {
			const [items, itemSets] = await Promise.all([
				auth.db.collection('Items').find(),
				auth.db.collection('ItemSets').find()
			]);
			
			const processedItems = items.map(d => ({
				...d,
				id: d._id["$oid"] || d._id.toString()
			}));
			
			const processedItemSets = itemSets.map(d => ({
				...d,
				id: d._id["$oid"] || d._id.toString()
			}));
			
			const itemSet = processedItemSets.find(d => d.id === survey.itemSet);
			if (!itemSet) {
				throw new Error('ItemSet not found for survey');
			}
			
			let [itemIDs, itemSetIDs] = getItemIDs(itemSet, processedItemSets);
			itemSetIDs.push(itemSet.id);
			
			let rotatorItemIDs = [];
			let rotatorItemSetIDs = [];
			
			if (itemSet.rotators && itemSet.rotators.length > 0) {
				rotatorItemSetIDs = itemSet.rotators.map(d => d.element);
				const rotatorItemSets = processedItemSets.filter(d => rotatorItemSetIDs.includes(d.id));
				
				for (let rotatorItemSet of rotatorItemSets) {
					rotatorItemIDs = rotatorItemIDs.concat(
						rotatorItemSet.elements.map(d => d.element)
					);
				}
			}
			
				return {
					Survey: survey,
					ItemSet: itemSet,
					Items: processedItems.filter(d => itemIDs.includes(d.id)),
					ItemSets: processedItemSets.filter(d => itemSetIDs.includes(d.id)),
					RotatorItems: processedItems.filter(d => rotatorItemIDs.includes(d.id)),
					RotatorItemSets: processedItemSets.filter(d => rotatorItemSetIDs.includes(d.id)),
					TestRetestExplanationItem: processedItems.find(d => d.id === '61cdf469f43e617559227ea1') || null,
					error: null
				};
			
		} catch (err) {
			console.error('Failed to get survey items:', err);
			throw err;
		}
	};

	async function loadSurvey(auth) {

		document.getElementById('err-notNumber').style.height = "0px";
		document.getElementById('err-notYetOpen').style.height = "0px";
		document.getElementById('err-closed').style.height = "0px";
		document.getElementById('err-noSurvey').style.height = "0px";

		var accessCode = document.getElementById('ac1').value + document.getElementById('ac2').value + document.getElementById('ac3').value + document.getElementById('ac4').value + document.getElementById('ac5').value + document.getElementById('ac6').value;
		accessCode = accessCode.toUpperCase();

		try {
			let survey = null;
			
			if (window.location.hostname == "resourceboxsurvey.org") {
				// Handle JGI surveys
				let surveyId = null;
				if (JGIcodes['lower_pre'].includes(accessCode)) {
					surveyId = '716250';
				} else if (JGIcodes['upper_pre'].includes(accessCode)) {
					surveyId = '164986';
				} else if (JGIcodes['lower_post'].includes(accessCode)) {
					surveyId = '365746';
				} else if (JGIcodes['upper_post'].includes(accessCode)) {
					surveyId = '583713';
				} else if (JGIcodes['staff'].includes(accessCode)) {
					surveyId = '815181';
				}
				
				if (surveyId) {
					const surveys = await auth.db.collection('Surveys').find({ _id: surveyId });
					if (surveys.length > 0) {
						survey = { Survey: surveys[0], error: null };
						
						// Get survey items if itemSet exists
						if (survey.Survey.itemSet) {
							try {
								const surveyItems = await getSurveyItems(survey.Survey, auth);
								survey = surveyItems;
							} catch (err) {
								console.warn('Failed to load items for survey:', err);
							}
						}
					}
				}
				
				if (survey && survey.error === null) {
					setPage(prevPage => {
						let page = {...prevPage};
						page.survey = survey;
						page.id = 'Survey';
						page.accessCode = accessCode;
						return page;
					})
				} else {
					showError('noSurvey');
				}
			} else {
				// Handle regular surveys
				if (!/^\d{6}$/.test(accessCode)) {
					showError('notNumber');
					return;
				}
				
				const surveys = await auth.db.collection('Surveys').find({ accessCode: accessCode });
				if (surveys.length > 0) {
					survey = { Survey: surveys[0], error: null };
					
					// Get survey items if itemSet exists
					if (survey.Survey.itemSet) {
						try {
							const surveyItems = await getSurveyItems(survey.Survey, auth);
							survey = surveyItems;
						} catch (err) {
							console.warn('Failed to load items for survey:', err);
						}
					}
					
					if (beforeOpenDate(survey.Survey.openDate)) {
						showError('notYetOpen');
					} else if (afterCloseDate(survey.Survey.closeDate)) {
						showError('closed');
					} else {
						setPage(prevPage => {
							let page = {...prevPage};
							page.survey = survey;
							page.id = 'Survey';
							return page;
						})
					}
				} else {
					showError('noSurvey');
				}
			}
		} catch(err) {
			console.error('Survey lookup failed:', err);
			showError('noSurvey');
		}
	}

	function getLogo() {
		if (theme !== null) {
			if (theme.hasOwnProperty('logo') && theme.logo !== '') {
				return 'static/img/logos-large/' + theme.logo;
			}
		}
		return 'static/img/transparent-placeholder.png';
	}

	function getCopyright() {
		if (theme !== null) {
			if (theme.hasOwnProperty('copyrightSurvey') && theme.copyrightSurvey !== '') {
				let copyright = theme.copyrightSurvey;
				copyright = copyright.replace('{{YEAR}}', (new Date()).getFullYear());
				return { html: copyright };
			}
		}
		return '';
	}

	return html`
		<main>
		<div class="login">
			
		<img src="${getLogo()}" class="logo" alt="Organisation logo"/>
			
			<span class="prompt" id="loginPrompt">${window.location.hostname == "resourceboxsurvey.org" ? 'PLEASE ENTER YOUR 6-LETTER ACCESS CODE' : text.loginPrompt}</span><br />
			<div id="shakediv">
				<input type="number" pattern="[0-9]" inputmode="numeric" id="ac1" aria-label="Access code input box 1" maxlength="1" max="9" min="0" size="1" onfocus="${onFocusEvent(1)}" onkeypress="${handleKeyPress(1)}" autofocus>&ensp;
				<input type="number" pattern="[0-9]" inputmode="numeric" id="ac2" aria-label="Access code input box 2" maxlength="1" max="9" min="0" size="1" onfocus="${onFocusEvent(2)}" onkeypress="${handleKeyPress(2)}">&ensp;
				<input type="number" pattern="[0-9]" inputmode="numeric" id="ac3" aria-label="Access code input box 3" maxlength="1" max="9" min="0" size="1" onfocus="${onFocusEvent(3)}" onkeypress="${handleKeyPress(3)}">&ensp;
				<input type="number" pattern="[0-9]" inputmode="numeric" id="ac4" aria-label="Access code input box 4" maxlength="1" max="9" min="0" size="1" onfocus="${onFocusEvent(4)}" onkeypress="${handleKeyPress(4)}">&ensp;
				<input type="number" pattern="[0-9]" inputmode="numeric" id="ac5" aria-label="Access code input box 5" maxlength="1" max="9" min="0" size="1" onfocus="${onFocusEvent(5)}" onkeypress="${handleKeyPress(5)}">&ensp;
				<input type="number" pattern="[0-9]" inputmode="numeric" id="ac6" aria-label="Access code input box 6" maxlength="1" max="9" min="0" size="1" onfocus="${onFocusEvent(6)}" onkeypress="${handleKeyPress(6)}">
			</div><br />
			
			<div id="loading-animation" class="loader" aria-live="polite" aria-label="Loading survey">
				<div class="elements">
					<div class="circle1"></div>
					<div class="circle2"></div>
				</div>
			</div>
			
			<div aria-live="assertive" aria-atomic="true">
				<span id="err-notNumber" class="error" style="height:0px"><strong>${text.errorNotNumber.strong}</strong><br />${text.errorNotNumber.plain}</span>
				<span id="err-notYetOpen" class="error" style="height:0px"><strong>${text.errorNotYetOpen.strong}</strong><br /><span id="openDateErrorMessage"></span></span>
				<span id="err-closed" class="error" style="height:0px"><strong>${text.errorClosed.strong}</strong><br /><span id="closeDateErrorMessage"></span></span>
				<span id="err-noSurvey" class="error" style="height:0px"><strong>${text.errorNoSurvey.strong}</strong><br />${text.errorNoSurvey.plain}</span>
				<span id="err-admin" class="error" style="height:0px"><strong>${text.errorContact.strong}</strong><br />${text.errorContact.plain}</span>
			</div>
				
		</div>
		</main>

		<div class="fineprint">${getCopyright()}</div>

		<div class="top-controls">
			<div class="translation">${Select(
				[
					{label: '🇦🇺 English', value: 'EN'},
					{label: '🇨🇳 Traditional Chinese', value: 'YUE'},
					{label: '🇨🇳 Simplified Chinese', value: 'CMN'},
				],
				language,
				setLanguage,
				false, {}, false, false
			)}</div>
			<div class="a11y-widget">
				${a11yOpen ? html`<div class="curtain" onclick="${() => setA11yOpen(false)}"></div>` : ''}
				<button class="a11y-toggle" onclick="${() => setA11yOpen(o => !o)}" aria-expanded="${a11yOpen}" aria-label="Accessibility options" data-tooltip="Accessibility options"><i class="fas fa-universal-access" aria-hidden="true"></i></button>
				${a11yOpen ? html`
					<div class="a11y-panel" role="dialog" aria-label="Accessibility options">
						<label class="a11y-slider-label">Contrast<input type="range" min="50" max="200" value="${a11y.highContrast}" oninput="${slideA11y('highContrast')}" aria-label="Contrast" /></label>
						<label class="a11y-slider-label">Text size<input type="range" min="10" max="28" value="${a11y.largeText}" oninput="${slideA11y('largeText')}" aria-label="Text size" /></label>
						<label><input type="checkbox" checked="${a11y.reducedMotion}" onchange="${() => toggleA11y('reducedMotion')}" /> Reduce motion</label>
						<label><input type="checkbox" checked="${a11y.noBg}" onchange="${() => toggleA11y('noBg')}" /> Remove background image</label>
					</div>
				` : ''}
			</div>
		</div>
	`;

});

export default Login;